// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__a41jx","label":"CategoryService_label__1KHlR","location":"CategoryService_location__2XmZ2"};